import {
  AbstractControlOptions,
  FormArray,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { PledgeDocumentRead } from '@app/forms/subscription/definition/interface/Pledge';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';

export abstract class EaDocumentFormBuilder extends PrFormAbstract {
  constructor(
    protected formConstructor: PrFormConstructor,
    protected subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  generate(entity: PledgeDocumentRead, option) {
    let options: AbstractControlOptions = {};

    return this.formBuilder.group(
      {
        id: [entity?.id || null],
        document: [entity ? entity?.document : null, Validators.required],
        label: [entity?.label || null],
        dateCreated: [entity?.dateCreated || null],
        reviewed: [entity?.reviewed || null],
        isSigned: [entity?.isSigned || null],
        category: ['CIVIL_STATE'],
        accountId: [entity ? entity?.accountId : null],
      },
      options,
    );
  }

  extractDocument() {
    const pledge = this.subscriptionFacade.getPledge();

    let uploadForm: FormGroup = this.formBuilder.group({
      label: this.utilsService.emptyIsNull(this.form.value.label),
      dateCreated: this.utilsService.emptyIsNull(this.form.value.dateCreated),
      category: 'CIVIL_STATE',
      reviewed: this.utilsService.emptyIsNull(this.form.value.reviewed),
      isSigned: this.utilsService.emptyIsNull(this.form.value.isSigned),
      document: this.utilsService.emptyIsNull(this.form.value.document),
      dateExpired: this.utilsService.emptyIsNull(this.form.value.dateExpired),
      accountId: this.utilsService.emptyIsNull(this.form.value.accountId),
      id: this.utilsService.emptyIsNull(this.form.value.id),
      ownerIds: this.utilsService.emptyIsNull(this.findOwners(pledge)),
    });
    return uploadForm;
  }

  findOwners(pledge: any) {
    let ownerIds = new FormArray([]);
    if (pledge?.parameters?.subscriberType) {
      if (
        pledge?.parameters?.subscriberType === 'COMPANY' &&
        pledge?.owners?.length
      ) {
        ownerIds.push(new FormControl(pledge.owners[0].company.id));
      } else if (pledge?.owners?.length) {
        pledge.owners.forEach(owner => {
          ownerIds.push(new FormControl(owner.ownerId));
        });
      }
    }
    return ownerIds;
  }
}
